import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSEO } from '@/hooks/useSEO';
import BlogHero from './components/BlogHero';
import BlogRecognition from './components/BlogRecognition';
import BlogCore from './components/BlogCore';
import BlogSolutions from './components/BlogSolutions';
import BlogInsights from './components/BlogInsights';
import BlogConvert from './components/BlogConvert';

const StickyConsultCTA = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-8 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-6 pointer-events-none'
      }`}
    >
      <button
        onClick={() => navigate('/consultations')}
        className="flex items-center gap-3 px-7 py-3.5 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-bold rounded-full whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
        style={{ boxShadow: '0 8px 32px rgba(139,92,246,0.45)' }}
      >
        <div className="w-5 h-5 flex items-center justify-center shrink-0">
          <i className="ri-calendar-line text-base" />
        </div>
        {t('blog_sticky_cta')}
        <div className="w-5 h-5 flex items-center justify-center shrink-0">
          <i className="ri-arrow-right-line text-base" />
        </div>
      </button>
    </div>
  );
};

const BlogPage = () => {
  useSEO({
    title: 'Blog | ZpiritualZ – Spirituele Kennis over Bescherming, Hing & Rituelen',
    description: 'Lees alles over spirituele bescherming, hing-rituelen, het boze oog en eeuwenoude tradities op de ZpiritualZ blog. Praktische gidsen, rituelen en inzichten voor dagelijkse bescherming tegen negatieve energie.',
    canonical: 'https://www.zpiritualz.com/blog',
    keywords: 'spirituele blog, hing ritueel, boze oog bescherming, spirituele bescherming gids, asafoetida ritueel, negatieve energie verwijderen',
    ogImage: 'https://public.readdy.ai/ai/img_res/13b72bd0371365bb42390352d210af94.jpg',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'ZpiritualZ Blog',
      url: 'https://www.zpiritualz.com/blog',
      description: 'Spirituele kennis over bescherming, hing-rituelen, het boze oog en eeuwenoude tradities.',
      publisher: {
        '@type': 'Organization',
        name: 'ZpiritualZ',
        url: 'https://www.zpiritualz.com',
      },
      inLanguage: ['nl', 'en', 'es'],
    },
  });

  return (
  <div className="min-h-screen bg-[#050010] pt-20">
    <StickyConsultCTA />
    <BlogHero />
    <BlogRecognition />
    <BlogCore />
    <BlogSolutions />
    <BlogInsights />
    <BlogConvert />
  </div>
  );
};

export default BlogPage;
